(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCommanderDiscretion.factory:AdminCommanderDiscretionFactory
     *
     * @description
     *
     */
    angular
        .module('adminCommanderDiscretion')
        .factory('AdminCommanderDiscretionFactory', AdminCommanderDiscretionFactory);
    
    function AdminCommanderDiscretionFactory() {

        function SearchCriteriaDTO() {
    		this.cdr = null;
    		this.sector = null;
    		this.submitedBy = null;
    		this.approvedBy = null;
    		this.status = null;
    		
    		this.dateOccurred = null;
    		this.dateGCAASubmitted = null;
    		this.emailStatus = null;
    		
            this.pageSize = null;
            this.startPosition = null;
            this.id = null;
        }
        

		function CrewDescretionDTO() {
			this.cmdDescretionId = null;
			this.crewTypeCode = null;
			this.status = null;
			this.cdr = null;
			this.acTypes = null;
			this.acRegestrations = null;
			this.submitedCrewName = null;
			this.submitedCrewId = null;
			this.emailSentStatus = null;
			this.emailDueDate = null;
			this.color = null;
		}
		
        function FormattedDescretion(params) {
            var descretion =  new CrewDescretionDTO();
            descretion.cmdDescretionId = params.cmdDescretionId;
            descretion.crewTypeCode = params.crewTypeCode;
            descretion.status = params.status  ;
            descretion.cdr = params.cdr;
            descretion.acTypes = params.acTypes;
            
            descretion.acRegestrations = params.acRegestrations;
            descretion.submitedCrewName = params.submitedCrewName;
            descretion.submitedCrewId = params.submitedCrewId;
            descretion.emailSentStatus = params.emailSentStatus == 'Y' ? 'Yes' : 'No';
            descretion.departureDate = params.departureDate ;
            descretion.emailDueDate = params.emailDueDate === '-' ? '-' : (parseInt(params.emailDueDate / 60) + " : " +  Math.abs(parseInt(params.emailDueDate % 60)));
            descretion.color = params.color ;
//            descretion.color = '#b4e5af' ;
            return descretion;
        }
        
        function GetCmdDescretionSearchRequest() {
            return new SearchCriteriaDTO() ;
        }
        
        function FormattedCmdDescretionCollection(descretionList){
        	var formattedList = [];
            angular.forEach(descretionList, function (descretion) {
                formattedList.push(FormattedDescretion(descretion))
            });
            return formattedList;
        }
        
        function GetCmndDescretionDetailSearchrequest(postData){
        	var data = new SearchCriteriaDTO() ;
        	data.id = postData.cmdDescretionId;
        	return data;
        }
        
        return {
        	getCmdDescretionSearchRequest: GetCmdDescretionSearchRequest,
            formattedCmdDescretionCollection: FormattedCmdDescretionCollection,
            getCmndDescretionDetailSearchrequest : GetCmndDescretionDetailSearchrequest
        }
    }
})();